import { Controller } from "@hotwired/stimulus";
import parsePhoneNumber from "libphonenumber-js";

export default class extends Controller {
  static targets = ["phoneValue", "prefix"];
  static values = { phone: String, prefix: String };

  connect() {
    const parsedPhone = parsePhoneNumber(this.phoneValueTarget.value);
    const prefix = parsedPhone ? `+${parsedPhone.countryCallingCode}` : "+33";
    this.prefixTarget.value = prefix;
    this.prefixValue = prefix;
    this.phoneValue = parsedPhone?.nationalNumber || "";

    // Store reference to dropdown controller
    this._dropdownElement = this.element.querySelector('[data-controller*="ui--dropdown"]');

    // Use document-level delegation for portaled dropdown clicks
    this._handlePrefixClick = this.handlePrefixClick.bind(this);
    document.addEventListener('click', this._handlePrefixClick);
  }

  disconnect() {
    document.removeEventListener('click', this._handlePrefixClick);
  }

  handlePrefixClick(e) {
    const menuOption = e.target.closest('[data-phone-prefix]');
    if (!menuOption) return;

    // Check if this click belongs to our dropdown by checking if the dropdown is open
    const dropdownController = this._dropdownElement &&
      this.application.getControllerForElementAndIdentifier(this._dropdownElement, "ui--dropdown");

    if (!dropdownController || !dropdownController.openedValue) return;

    e.preventDefault();
    e.stopPropagation();

    this.prefixValue = menuOption.dataset.value;
    this.prefixTarget.value = this.prefixValue;
    this.handleValue();
    dropdownController.hide();
  }

  changePrefix(e) {
    e.preventDefault();
    const element = e.target.closest("[data-value]");
    if (element) {
      this.prefixValue = element.dataset.value;
      this.prefixTarget.value = this.prefixValue;
      this.handleValue();
    }
  }

  changePhone(e) {
    e.preventDefault();
    this.phoneValue = e.target.value;
    this.handleValue();
  }

  handleValue() {
    const numberToParse = `${this.prefixValue}${this.phoneValue}`;
    const parsedPhone = parsePhoneNumber(numberToParse);
    const prefix = parsedPhone ? `+${parsedPhone.countryCallingCode}` : this.prefixValue || "+33";
    this.prefixTarget.value = prefix;
    this.prefixValue = prefix;
    const finalPhone = parsedPhone?.number || "";
    this.phoneValueTarget.value = finalPhone;
    this.phoneValueTarget.setAttribute("value", finalPhone);
  }
}
